module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the patient love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the kind love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the protecting love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the trusting love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the hopeful love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the persevering love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Behold the unconditional love of God")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("It does not envy, it does not boast")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("It is not proud, it is not rude")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("It is not self-seeking, it is not easily angered")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("It keeps no record of wrongs,")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("it does not delight in evil but rejoices in the truth")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("It never fails")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Prophecies, tongues and knowledge will cease,")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("still and pass away")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Faith, hope and love remain")])])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("But the greatest of these is love")])])]), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('i', [_vm._v("Become what you receive")])])]), _c('p', {
    staticClass: "auteur"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 13: 4-13"), _c('br'), _vm._v("AS ADAPTED BY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACCHIA")])])])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0